import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  VStack,
  Tag,
  Text,
  HStack,
  useQuery,
  Box,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { User } from "types";

export const UsersTable = ({
  users,
  page,
  totalPages,
  setPage,
}: {
  users: User[];
  page: number;
  totalPages: number;
  setPage: (page: number) => void;
}) => {
  const { t, i18n } = useTranslation();
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString(
      i18n.language === "pt-BR" ? "pt-BR" : "en-US"
    );
  };
  return (
    <Box>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>{t("users.history.id")}</Th>
            <Th>{t("users.history.client")}</Th>
            <Th>{t("users.history.affiliateId")}</Th>
            <Th>{t("users.history.subscription")}</Th>
            <Th>{t("users.history.actions")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users &&
            users.map((user) => (
              <Tr key={user.id}>
                <Td>
                  <VStack align="flex-start">
                    <Tag colorScheme="gray">{user.id}</Tag>
                    <Tag colorScheme="gray">
                      Criado em: {formatDate(user.createdAt!)}
                    </Tag>
                  </VStack>
                </Td>
                <Td>
                  <VStack align="flex-start">
                    <Text fontSize="sm">{user.firstName} </Text>
                    <Tag colorScheme="teal">{user.email}</Tag>
                    {user.cpf && <Tag colorScheme="teal">CPF: {user.cpf}</Tag>}
                  </VStack>
                </Td>
                <Td>
                  <Tag colorScheme="teal">
                    {user.affiliateId ? user.affiliateId : "Não"}
                  </Tag>
                </Td>
                <Td>
                  <VStack align="flex-start">
                    <Tag colorScheme="blue">
                      Plano: {user.subscription?.plan}
                    </Tag>
                    <Tag colorScheme="teal">
                      Pagamentos (SUM):{" "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(
                        user.payments?.reduce(
                          (acc, payment) =>
                            acc +
                            (payment.status === "PAID"
                              ? Number(payment.amount)
                              : 0),
                          0
                        ) || 0
                      )}
                    </Tag>
                    <Tag colorScheme="green">
                      Saldo:{" "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(user.subscription?.credits || 0)}
                    </Tag>
                    <Tag colorScheme="gray">
                      Status: {user.subscription?.status}
                    </Tag>
                  </VStack>
                </Td>
                <Td>
                  <HStack spacing={2}>
                    <Text>TODO</Text>
                  </HStack>
                </Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
      {/* Add pagination controls */}
      <HStack spacing={2} justify="space-between" w="full">
        <Button
          onClick={() => setPage(Math.max(1, page - 1))}
          isDisabled={page === 1}
        >
          {t("common.previous")}
        </Button>
        <Text>
          {t("common.page")} {page} / {totalPages}
        </Text>
        <Button
          onClick={() => setPage(Math.min(totalPages, page + 1))}
          isDisabled={page === totalPages}
        >
          {t("common.next")}
        </Button>
      </HStack>
    </Box>
  );
};
